<template>
  <transition name="upload-bar-slide">
    <div v-if="progressTotal > 0" class="upload-fixed-bar">
      <div class="upload-fixed-bar__inner">
        <div class="upload-fixed-bar__row">
          <span class="upload-fixed-bar__label">
            <i
              class="fas mr-2"
              :class="progressIconClass"
            ></i>

            <template v-if="isItemsMode">
              <span v-if="hasUploading">Загрузка фотографий</span>
              <span v-else-if="errorCount > 0" class="text-danger">Есть ошибки</span>
              <span v-else class="text-success">Фотографии загружены</span>
            </template>
            <template v-else>
              <span v-if="uploadProgressSafeDone < uploadProgressSafeTotal">Загрузка фотографий</span>
              <span v-else-if="photosProcessingStatus === 'processing'" class="text-success">
                Загружено · обрабатывается&hellip;
              </span>
              <span v-else class="text-success">Фотографии загружены</span>
            </template>
          </span>

          <span class="upload-fixed-bar__counter">
            {{ progressReadyCount }} / {{ progressTotal }}
          </span>
        </div>

        <b-progress
          :value="progressReadyCount"
          :max="progressTotal"
          :variant="progressVariant"
          :animated="isItemsMode ? hasUploading : uploadProgressSafeDone < uploadProgressSafeTotal"
          height="5px"
          class="upload-fixed-bar__progress"
        ></b-progress>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'PhotoUploadProgressBar',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    uploadProgress: {
      type: Object,
      default: () => ({ done: 0, total: 0 })
    },
    photosProcessingStatus: {
      type: String,
      default: null
    },
    readyCount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    isItemsMode() {
      return Array.isArray(this.items) && this.items.length > 0;
    },
    itemsSafe() {
      if (!Array.isArray(this.items)) return [];
      return this.items.filter(i => i && ['uploading', 'ready', 'error'].includes(i.status));
    },
    progressTotal() {
      if (this.isItemsMode) return this.itemsSafe.length;
      return this.uploadProgressSafeTotal;
    },
    errorCount() {
      if (!this.isItemsMode) return 0;
      return this.itemsSafe.filter(i => i.status === 'error').length;
    },
    hasUploading() {
      if (!this.isItemsMode) return false;
      return this.itemsSafe.some(i => i.status === 'uploading');
    },
    progressReadyCount() {
      if (this.isItemsMode) {
        const ready = this.itemsSafe.filter(i => i.status === 'ready').length;
        return Math.min(Math.max(ready, 0), this.progressTotal);
      }
      return this.readyCountSafe;
    },
    progressVariant() {
      if (this.isItemsMode) {
        if (this.errorCount > 0 && this.progressReadyCount < this.progressTotal) return 'danger';
        if (this.progressReadyCount >= this.progressTotal && this.progressTotal > 0) return 'success';
        return 'primary';
      }
      return this.uploadProgressSafeDone >= this.uploadProgressSafeTotal && this.uploadProgressSafeTotal > 0
        ? 'success'
        : 'primary';
    },
    progressIconClass() {
      if (this.isItemsMode) {
        if (this.hasUploading) return 'fa-cloud-upload-alt';
        if (this.errorCount > 0) return 'fa-exclamation-triangle text-danger';
        return 'fa-check-circle text-success';
      }

      return this.uploadProgressSafeDone < this.uploadProgressSafeTotal
        ? 'fa-cloud-upload-alt'
        : 'fa-check-circle text-success';
    },
    uploadProgressSafeDone() {
      const done = this.uploadProgress && this.uploadProgress.done;
      return Number(done) > 0 ? Number(done) : 0;
    },
    uploadProgressSafeTotal() {
      const total = this.uploadProgress && this.uploadProgress.total;
      return Number(total) > 0 ? Number(total) : 0;
    },
    readyCountSafe() {
      const total = this.uploadProgressSafeTotal;
      if (!total) return 0;

      const ready = Number(this.readyCount);
      if (Number.isNaN(ready)) return 0;
      return Math.min(Math.max(ready, 0), total);
    }
  }
};
</script>

<style lang="scss" scoped>
.upload-fixed-bar {  
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background: #fff;
  border-top: 1px solid #dee2e6;
  box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.10);
  padding: 10px 16px 12px;

  &__inner {
    max-width: 640px;
    margin: 0 auto;
  }

  &__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;
  }

  &__label {
    font-size: 13px;
    font-weight: 500;
    color: #495057;
    display: flex;
    align-items: center;

    .fa-cloud-upload-alt {
      color: #007bff;
    }
  }

  &__counter {
    font-size: 12px;
    color: #6c757d;
    white-space: nowrap;
    margin-left: 8px;
  }

  &__progress {
    border-radius: 3px;
  }
}

// Анимация появления снизу
.upload-bar-slide-enter-active,
.upload-bar-slide-leave-active {
  transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.28s ease;
}
.upload-bar-slide-enter,
.upload-bar-slide-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>

